"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var ImageAssetType;
(function (ImageAssetType) {
    ImageAssetType["HeroLandingWide"] = "heroLandingWide";
    ImageAssetType["HeroLandingSquare"] = "heroLandingSquare";
    ImageAssetType["ContentTileHorizontal"] = "contentTileHorizontal";
    ImageAssetType["ContentTileVertical"] = "contentTileVertical";
    ImageAssetType["ContentDetail"] = "contentDetail";
})(ImageAssetType = exports.ImageAssetType || (exports.ImageAssetType = {}));
//# sourceMappingURL=ImageAssetType.js.map